import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const gsapFullsizeTitle = (function ($) {

    gsap.registerPlugin(ScrollTrigger);

    let $fixedContainer = gsap.utils.toArray(".js-gsap-fullsize-title-container");

    function init() {

        if ($fixedContainer) {
            ScrollTrigger.matchMedia({
                // desktop
                "(min-width: 1024px) and (prefers-reduced-motion: no-preference)": function() {
                    // pinned element only on desktop
                    $fixedContainer.forEach(function(elem) {

                        let $fixedElements1 = elem.querySelectorAll(".js-gsap-fullsize-title-item-1");
                        let $fixedElements2 = elem.querySelectorAll(".js-gsap-fullsize-title-item-2");
                        let $fixedElements3 = elem.querySelectorAll(".js-gsap-fullsize-title-item-3");

                        let tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: elem,
                                scrub: 1,
                                pin: true,
                                start: "top top",
                                end: "+=100%"
                            }
                        });

                        tl.fromTo($fixedElements1, {yPercent: 10, opacity: 0, scale: 1.2}, {yPercent: 0, opacity: 1, scale: 1})
                            .fromTo($fixedElements2, {yPercent: 10, opacity: 0, scale: 1.2}, {yPercent: 0, opacity: 1, scale: 1})
                            .fromTo($fixedElements3, {yPercent: 10, opacity: 0, scale: 1.2}, {yPercent: 0, opacity: 1, scale: 1});

                    })
                },
                // mobile
                "(max-width: 1023px)": function() {

                }
            })

        }

    }

    return {
        init: init
    }

})(jQuery);